<template>
  <section class="container">
    <el-form>
      <el-form-item label="图片">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <img
          v-if="buyData.content"
          :src="qiniuDomain + buyData.content"
          class="about-img" >
      </el-form-item>
      <el-form-item label="英文图片">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadEnglishSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <img
          v-if="buyData.english_content"
          :src="qiniuDomain + buyData.english_content"
          class="about-img" >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSave">保存</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  buy, buyEdit,
} from '@/api/about'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      buyData: {
        content: '',
        uuid: '',
      },
    };
  },

  created() {
    this.network().getQiniuInfo()
    this.network().buy()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    onSave() {
      this.network().buyEdit()
    },
    uploadSuccess(res) {
      this.buyData.content = res.hash
    },
    uploadEnglishSuccess(res) {
      this.buyData.english_content = res.hash
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        buy: async () => {
          const { status, data } = await buy()
          if (status === 200) {
            this.buyData = data
          }
        },
        buyEdit: async () => {
          const { status } = await buyEdit(this.buyData)
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
  .about-img {
    max-width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/about/buy.vue